import get from 'lodash.get';

const getCustomColors = (state) => get(state, 'ws.site.meta.customization.customColors', []);

export default getCustomColors;
